import { ActionType } from 'src/types/common/common';
import { ResponsiveGridAdaptor } from 'src/constrains/DraggableModules/Components';

const ResponsiveProductGridFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnGridItemReselect = (id, products) => {
    // const _n = optionsToNum[posterType] || 1;
    // const _o = data || [generateResponsiveImage()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: products });
    }
  };

  const handleOnGridItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnGridItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnGridStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnGridModuleTypeChange = (data) => {
    //console.log(123123123123123);
    //console.log('typedata', data);
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  return {
    handleOnGridItemReselect,
    handleOnGridItemDelete,
    handleOnGridItemSort,
    handleOnGridStaticChange,
    handleOnGridModuleTypeChange,
  };
};
const generateResponsiveProductGrid = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const {
    handleOnGridItemReselect,
    handleOnGridItemDelete,
    handleOnGridItemSort,
    handleOnGridStaticChange,
    handleOnGridModuleTypeChange,
  } = ResponsiveProductGridFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ResponsiveGridAdaptor,
    props: {
      onItemReselect: handleOnGridItemReselect,
      onItemSort: handleOnGridItemSort,
      onItemDelete: handleOnGridItemDelete,
      onStaticChange: handleOnGridStaticChange,
      onModuleTypeChange: handleOnGridModuleTypeChange,
    },
  };
};
export { generateResponsiveProductGrid };
